import Vue from 'vue';
import VueRouter from 'vue-router';
import Interface from '../views/interface.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Interface',
    component: Interface,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
